
import { Component, InjectReactive, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class';

import RewardContactModal from '@/components/RewardContactModal.vue';
import UserModule from '@/store/modules/user';
import { hideCMSContent } from '@/utils/global.util';

@Component({
  components: {
  }
})
export default class Rewards extends Vue {
  @InjectReactive('progressRef') progressRef: any;
  @Getter activeRestaurant!: Restaurant;
  @InjectReactive() isMobile!: boolean;
  get rewards(): LoyaltyAccountReward[] {
    return UserModule.loyaltyAccountRewards;
  }

  pointsRequiredText(pointsRequiredToRedeem) {
    const pointsNeeded = pointsRequiredToRedeem - UserModule.currentPoints;
    if (pointsNeeded === 1) {
      return '1 more point';
    }
    return `${pointsNeeded} more points`;
  }

  handleSubmit(reward: LoyaltyAccountReward) {
    if (!reward.showContactForm) {
      hideCMSContent();
      if (this.activeRestaurant?.id) {
        this.$router.push({
          name: 'ChooseFood',
          params: {
            ...this.$route.params,
            location: this.activeRestaurant.slug,
          }
        });
      } else {
        this.$router.push({
          name: 'SelectLocation'
        });
      }

      this.$scrollTo(this.$refs.container as Element);
    } else {
      this.$modal.show(
        RewardContactModal, {
          rewardName: reward.name
        }, {
          clickToClose: true,
          scrollable: true,
          focusTrap: true,
          height: 'auto',
          width: this.isMobile ? '90%' : '60%',
        }
      );
    }
  }
}
